<template>
  <div class="script-key-value-paris">
    <div class="list-item" style="text-align: center;" v-if="!_.isEmpty(list)">
      <span style="width: 30%">参数名</span>
      <span style="flex:1">{{ from === "tree" ? "参数值" : "参数类型" }}</span>
    </div>
    <div v-for="(item, index) in list" :key="index" class="list-item">
      <el-input v-model="item.key" style="flex: 1"></el-input>
      <tree-select
        v-if="from === 'tree'"
        v-model="item.value.value"
        :group-list="workflowVarGroups"
        class="var-item"
      ></tree-select>
      <el-select v-else filterable v-model="item.value.value" class="var-item">
        <el-option
          v-for="item in controls"
          :key="item._type"
          :label="item.name"
          :value="item._type"
        ></el-option>
      </el-select>
      <div style="width: 30px;">
        <i class="el-icon-delete-solid icon-del" @click="delPair(index)"></i>
      </div>
    </div>
    <div class="mTop10">
      <span class="add-item" @click="addPair">{{ addItemText }}</span>
    </div>
  </div>
</template>

<script>
import mixin from "../components/setHttpRequest/mixin"
import TreeSelect from "@/components/UIComponents/TreeSelect"

export default {
  name: "ScriptKeyValueParis",
  components: {
    TreeSelect
  },
  props: {
    list: Array,
    workflowVarGroups: Array,
    controls: Array,
    addItemText: {
      type: String,
      default: "+"
    },
    title: {
      type: String,
      default: "key - value"
    },
    from: {
      type: String,
      default: "tree"
    }
  },
  mixins: [mixin],
  methods: {
    addPair() {
      if (!this.verifyPairs(this.list, "add")) return
      this.list.push({
        key: "",
        value: {
          label: "",
          value: "",
          inFlow: false
        }
      })
    },
    delPair(index) {
      this.list.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.script-key-value-paris {
  .list-item {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    &:hover {
      .icon-del {
        display: block;
      }
    }
    .var-item {
      flex: 2;
      margin-left: 10px;
    }
    .icon-del {
      cursor: pointer;
      color: #bdbdbd;
      margin-left: 10px;
      display: none;
      &:hover {
        color: #1e88e5;
      }
    }
  }
  .add-item {
    cursor: pointer;
    color: #9e9e9e;
    &:hover {
      color: #1e88e5;
    }
  }
}
</style>

<style lang="scss">
.setHttpRequest .pairs-list {
  .reset-border {
    .el-input__inner {
      border: 1px solid #ccc;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &:hover {
        border-color: #2196f3;
      }
    }
  }
}
</style>
